import axios from 'axios';

const client = axios.create({
  baseURL: '/api/consumer/v1',
  withCredentials: true,
});

let _refreshing = null;

client.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (
      error.response?.status === 401 &&
      !original._retry &&
      !original.url?.includes('/auth/refresh/')
    ) {
      original._retry = true;
      try {
        if (!_refreshing) {
          _refreshing = axios.post('/api/consumer/v1/auth/refresh/', {}, { withCredentials: true }).finally(() => {
            _refreshing = null;
          });
        }
        await _refreshing;
        return client(original);
      } catch {
        const { useAuth } = await import('@/store/useAuth');
        useAuth.getState().forceLogout();
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export const listCollections = () =>
  client.get('/me/favorite-collections/').then((r) => r.data);

export const getCollection = (id) =>
  client.get(`/me/favorite-collections/${id}/`).then((r) => r.data);

export const createCollection = (name, color, icon, order) =>
  client.post('/me/favorite-collections/', { name, color, icon, order }).then((r) => r.data);

export const updateCollection = (id, patch) =>
  client.patch(`/me/favorite-collections/${id}/`, patch).then((r) => r.data);

export const deleteCollection = (id) =>
  client.delete(`/me/favorite-collections/${id}/`).then((r) => r.data);

export const addItem = (collectionId, mlsNumber) =>
  client.post(`/me/favorite-collections/${collectionId}/items/`, { mls_number: mlsNumber }).then((r) => r.data);

export const bulkAddItems = (collectionId, mlsNumbers) =>
  client.post(`/me/favorite-collections/${collectionId}/items/`, { mls_numbers: mlsNumbers }).then((r) => r.data);

export const removeItem = (collectionId, mlsNumber) =>
  client.delete(`/me/favorite-collections/${collectionId}/items/${mlsNumber}/`).then((r) => r.data);
